import { Injectable } from '@angular/core';
import { LookupEntityTypes } from '../shared/models/general/lookup-entity-types';
import { LookupFiaStatus } from '../shared/models/general/lookup-fia-status';
import { LookupMediaTypes } from '../shared/models/general/lookup-media-types';
import { BrokerUser } from '../shared/models/users/broker-user';
import { FiaApplication } from '../shared/models/users/fia-application';
import { UserFullDetails } from '../shared/models/users/user-full-details';
import { UserProfile } from '../shared/models/users/user-profile';
import { UserRole } from '../shared/models/users/user-role';
import { Users } from '../shared/models/users/users';
import { LookupService } from './lookup.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  
  public sidenavExpanded: boolean= true;

  public userId: number = 0;
  public user: Users;
  public userProfile: UserProfile;
  public userFiaApplications: FiaApplication[] = [];
  public userRoles: UserRole[];
  public brokerUsers: BrokerUser[];
  public userEntity: LookupEntityTypes;
  public transactionEntity: LookupEntityTypes;
  public brokerEntity: LookupEntityTypes;
  public arbFacilitatorEntity: LookupEntityTypes;
  public fiaStatus: LookupFiaStatus[] = [];
  public mediaTypes: LookupMediaTypes[] = [];

  //Lookups
  public lookupCurrency: "";
  public lookupEntityType: LookupEntityTypes[];
  public fiaSupportingMediaTypes: {Id:number, Name:string}[] = [{Id:0,Name:'All'},{Id:1,Name:'FiaApplicationSharedSupportingDocuments'},{Id:2,Name:'FiaApplication'}];

  //Permissions
  public userIsBroker: boolean = false;

  constructor(public usersService: UserService, public lookupService: LookupService) {
    
  }

  public ValidateGlobalVars() {
    return new Promise(resolve => {
      if (!this.user || !this.userProfile || !this.lookupCurrency || !this.lookupEntityType) {
        this.GetUserDetails().then(()=>{
          this.GetLookupCurrencies().then(()=>{
            this.GetLookupEntityTypes().then(()=>{
              resolve(true);
            });
          });          
        });
      }
      else{
        resolve(true);
      }      
    });
  }

  public GetUserDetails() {
    return new Promise(resolve => {
      if(!this.userId){
        this.userId = Number.parseInt(localStorage.getItem('userId'));
      }
      this.usersService.GetUserDetails(this.userId).subscribe(
        (response: UserFullDetails) => {
          this.user = response.user;
          this.userProfile = response.profile;
          this.userFiaApplications = response.fiaApplications;
          this.userRoles = this.user.userRoles;
          this.brokerUsers = this.user.brokerUsers;
          this.CheckUserRoles();
          resolve(true);
        },
        (error) => {
          console.log(error);
          resolve(true);
        }
      )
    });
  }

  public GetLookupCurrencies() {
    return new Promise(resolve => {
      this.lookupService.GetCurrencies().subscribe(
        (response) => {
          this.lookupCurrency = response;
          resolve(true);
        },
        (error) => {
          console.log(error);
          resolve(true);
        }
      )
    });
  }

  public GetLookupEntityTypes() {
    return new Promise(resolve => {
      this.lookupService.GetEntityTypes().subscribe(
        (response) => {
          this.lookupEntityType = response;
          this.userEntity = <LookupEntityTypes>this.lookupEntityType.find(x=>x.description=="Users");
          this.transactionEntity = <LookupEntityTypes>this.lookupEntityType.find(x=>x.description=="Transactions");
          this.brokerEntity = <LookupEntityTypes>this.lookupEntityType.find(x=>x.description=="Brokers");
          this.arbFacilitatorEntity = <LookupEntityTypes>this.lookupEntityType.find(x=>x.description=="ArbFacilitators");
          resolve(true);
        },
        (error) => {
          console.log(error);
          resolve(true);
        }
      )
    });
  }

  public GetLookupFiaStatus() {
    return new Promise(resolve => {
      this.lookupService.GetFiaStatus().subscribe(
        (response) => {
          this.fiaStatus = response;
          resolve(true);
        },
        (error) => {
          console.log(error);
          resolve(true);
        }
      )
    });
  }

  public GetLookupMediaTypes() {
    return new Promise(resolve => {
      this.lookupService.GetMediaTypes().subscribe(
        (response) => {
          this.mediaTypes = response;
          resolve(true);
        },
        (error) => {
          console.log(error);
          resolve(true);
        }
      )
    });
  }

  private CheckUserRoles(){
    this.userRoles.forEach(element => {
      if(element.roleId == 3){ //User
        this.userIsBroker = false;
      }
      else if(element.roleId == 4){ //Broker
        this.userIsBroker = true;
      }
      else if(element.roleId == 1){ //Admin
        this.userIsBroker = true;
      }
    });
  }
  
}
